// Used in notifications.component.html

// Angular
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

// Moment
import moment from "moment";

// Services/Types/Helpers
import { DateString } from "@carnegie-learning/utility-types";
import { Notification } from "cli-types";

@Component({
    selector: "notifications-sent",
    templateUrl: "./notifications-sent.component.html",
    styleUrls: [
        "../../notifications.component.scss",
        "./notifications-sent.component.scss",
    ],
    standalone: false
})
export class NotificationsSentComponent implements OnInit {
    @Input() public notifications?: Notification[];

    @Output() editNotificationEvent = new EventEmitter<Notification>();
    @Output() deleteNotificationEvent = new EventEmitter<Notification>();

    editMode = false;
    confirmDelete = false;

    constructor() {}

    ngOnInit() {}

    formatDate(date: DateString) {
        if (!date) {
            return "N/A";
        }
        return moment(date).format("MM/DD/YYYY");
    }

    onClickEdit() {
        this.editMode = true;
    }

    onClickDelete() {
        this.confirmDelete = true;
    }

    cancel() {
        this.editMode = false;
        this.confirmDelete = false;
    }

    editNotification(notification: Notification) {
        this.editNotificationEvent.emit(notification);
        this.editMode = false;
    }

    getRecipientName(notification: Notification) {
        if (notification?.recipient?.userGUID) {
            return (
                notification.recipient.firstName +
                " " +
                notification.recipient.lastName
            );
        }
    }

    onClickDeleteConfirmed(notification: Notification) {
        this.deleteNotificationEvent.emit(notification);
        this.confirmDelete = false;
    }

    closeEditMode() {
        this.editMode = false;
    }
}
